import Stack from '@mui/material/Stack';

import AnimatedAvatar from '@webclient/components/pages/search/sections/results/real-time/components/voice-mode-chat/animated-avatar';
import useResetThreadOnExit from '@webclient/components/pages/search/sections/results/real-time/components/voice-mode-chat/hooks/useResetThreadOnExit';
import {
  StyledVoiceChatToolbarStack,
  StyledWrapperStack,
} from '@webclient/components/pages/search/sections/results/real-time/components/voice-mode-chat/styles';
import VoiceAssistantControlBar from '@webclient/components/voice-assistant-control-bar';

import LivekitRoomGateProvider from '@webclient/providers/LivekitRoomGateProvider';

import useAppSelector from '@webclient/hooks/useAppSelector';

import { roomInstance } from '@webclient/state/slices/search-session/utils/room-manager';

import CrossIcon from '~icons/knowz-iconify/cross';

import { IconButton } from '@knowz/knowz-ui';

type Props = {
  loadingView?: boolean;
};

export default function VoiceModeChat({ loadingView = false }: Props) {
  const isVoiceModeChatOn = useAppSelector(
    (state) => state.searchSession.voiceChatMode.mode,
  );
  const { handleExistVoiceModeChat } = useResetThreadOnExit();
  if (loadingView) {
    return (
      <StyledWrapperStack>
        <AnimatedAvatar loadingView />
      </StyledWrapperStack>
    );
  }

  if (!roomInstance) {
    return null;
  }

  return (
    <StyledWrapperStack>
      <LivekitRoomGateProvider
        room={roomInstance.get()}
        shouldRenderAudio
      >
        <AnimatedAvatar />
        <Stack
          gap={10}
          sx={{ textAlign: 'center' }}
        >
          <StyledVoiceChatToolbarStack>
            <VoiceAssistantControlBar />
            {isVoiceModeChatOn && (
              <IconButton
                onClick={handleExistVoiceModeChat}
                variant="contained"
                color="secondary"
                shape="fullRounded"
              >
                <CrossIcon />
              </IconButton>
            )}
          </StyledVoiceChatToolbarStack>
        </Stack>
      </LivekitRoomGateProvider>
    </StyledWrapperStack>
  );
}
